var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"nav flex-column nav-pills mb-3"},_vm._l((_vm.clientTabs),function(tab){return _c('li',{staticClass:"nav-item text-capitalize",class:{ 'd-none': _vm.isHidden('clients_'+tab) }},[_c('a',{staticClass:"nav-link",attrs:{"href":_vm.setTabLink(tab.link)}},[_vm._v(_vm._s(_vm.setCustomLabel(tab.name)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }